export default function YourInfoIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="11.5"
        cy="11.5"
        rx="10.5"
        ry="10.5"
        stroke="#4E7FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3334 15.5836H13.0287"
        stroke="#4E7FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6855 15.5833V10.625H10.3439"
        stroke="#4E7FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6171 7.12166C11.6171 7.28281 11.4864 7.41345 11.3253 7.41345C11.1641 7.41345 11.0335 7.28281 11.0335 7.12166C11.0335 6.96051 11.1641 6.82987 11.3253 6.82987"
        stroke="#4E7FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3251 6.83026C11.4863 6.83026 11.6169 6.9609 11.6169 7.12205"
        stroke="#4E7FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
